import { HF_ACCESS_TOKEN } from './constants.js';
import gsap from 'gsap';
export function handleBackgroundChange(selector) {
    const customInput = document.getElementById('customBackgroundInput');
    customInput.style.display = selector.value === 'custom' ? 'block' : 'none';
}
function updateLoadingProgress(status, element_id) {
    const imageElement = document.querySelector(`image[data-item-id="${element_id}"]`);
    if (!imageElement) {
        console.error(`SVG Image Element with data-item-id=${element_id} not found`);
        return;
    }

    const svgRoot = imageElement.closest('svg');

    // Calculate the center of the image
    const imageX = parseFloat(imageElement.getAttribute('x') || 0);
    const imageY = parseFloat(imageElement.getAttribute('y') || 0);
    const imageWidth = parseFloat(imageElement.getAttribute('width') || 0);
    const imageHeight = parseFloat(imageElement.getAttribute('height') || 0);
    const centerX = imageX + imageWidth / 2;
    const centerY = imageY + imageHeight / 2;

    // If status is not 'succeeded', start loading animations
    if (status === 'succeeded') {
        // Stop all ongoing animations
        gsap.killTweensOf(imageElement);
        gsap.killTweensOf('.my-loading-text-wave tspan');
    
        // Remove all added elements and classes
        const elementsToRemove = ['.my-loading-scan-line', '.my-loading-generating', '.my-loading-text-wave', 'rect.my-loading-bg', 'text.my-loading-text', '#my-loading-blur'];
        elementsToRemove.forEach(selector => {
            svgRoot.querySelectorAll(selector).forEach(el => el.remove());
        });
    
        imageElement.classList.remove('my-loading-image-opacity-change');
        imageElement.removeAttribute('filter');
        imageElement.style.opacity = 1;
        // Confetti animation
        const tl = gsap.timeline();
        for (let i = 0; i < 50; i++) {
            const confetti = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            confetti.setAttribute('class', 'my-confetti');
            confetti.setAttribute('x', Math.random() * imageWidth + imageX);
            confetti.setAttribute('y', Math.random() * imageHeight + imageY);
            confetti.setAttribute('width', '5');
            confetti.setAttribute('height', '5');
            svgRoot.appendChild(confetti);
            const color = `hsl(${Math.random() * 360}, 100%, 50%)`;
            tl.to(confetti, { y: "+=100", x: `+=${Math.random() * 100 - 50}`, duration: 0.01, opacity: 0, ease: "power1.in", backgroundColor: color });
        }

        // Remove confetti after the animation
        tl.eventCallback("onComplete", () => {
            svgRoot.querySelectorAll('.my-confetti').forEach(el => el.remove());
        });
    } else {
        // Stop all ongoing animations

        // Pulsate the image slowly to indicate loading
        // Pulsate the image slowly to indicate loading
       // gsap.to(imageElement, { opacity: 0.6, scale: 1.05, duration: 1, yoyo: true, repeat: -1, transformOrigin: '50% 50%' });

        // Apply a slight blur effect to the image
        let filter = svgRoot.querySelector('#my-loading-blur');
        if (!filter) {
            filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
            filter.setAttribute('id', 'my-loading-blur');
            const feGaussianBlur = document.createElementNS('http://www.w3.org/2000/svg', 'feGaussianBlur');
            feGaussianBlur.setAttribute('in', 'SourceGraphic');
            feGaussianBlur.setAttribute('stdDeviation', '5');
            filter.appendChild(feGaussianBlur);
            svgRoot.appendChild(filter);
        }
        imageElement.setAttribute('filter', 'url(#my-loading-blur)');

        // Wave animation for "Loading..." text
        let backgroundRect = svgRoot.querySelector('rect.my-loading-bg');
        if (!backgroundRect) {
            backgroundRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            backgroundRect.setAttribute('class', 'my-loading-bg');
            backgroundRect.setAttribute('x', centerX - (imageWidth / 2));
            backgroundRect.setAttribute('y', centerY - (imageHeight * 0.2)); // Adjust as needed for position
            backgroundRect.setAttribute('width', imageWidth);
            backgroundRect.setAttribute('height', imageHeight * 0.4); // Adjust as needed for size
            backgroundRect.setAttribute('fill', 'rgba(255,255,255,0.6)'); // Semi-transparent white
            svgRoot.appendChild(backgroundRect);
        }

        // Display the "This Takes Approx 12s" text
        let loadingText = svgRoot.querySelector('text.my-loading-text');
        if (!loadingText) {
            loadingText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            loadingText.setAttribute('class', 'my-loading-text');
            loadingText.setAttribute('x', centerX);
            loadingText.setAttribute('y', centerY);
            loadingText.style.fontSize = `${imageHeight * 0.15}px`; // Adjust as needed
            loadingText.style.textAnchor = 'middle';

            const lines = ["This Takes", "Approx 12s"];
            lines.forEach((line, index) => {
                const tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
                tspan.setAttribute('x', centerX);
                tspan.setAttribute('dy', index === 0 ? '0' : '0.8em'); // Vertical spacing between lines
                tspan.textContent = line;
                loadingText.appendChild(tspan);
            });

            svgRoot.appendChild(loadingText);
        }
    }
}
let generatedContentUrl = null; // Declare this at the beginning of the query_replicate function
const HEARTBEAT_INTERVAL = 5000; // 30 seconds
const activeConnections = {};


async function initWebSocket(url, sessionId) {
  return new Promise((resolve, reject) => {
    const ws = new WebSocket(url);
    let heartbeatTimeout;

    // Send a ping to the server to prevent the connection from timing out
    const sendHeartbeat = () => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({ type: 'heartbeat' }));
        }
    };

    // Set up heartbeat interval on successful connection
    ws.addEventListener('open', () => {
        ws.send(JSON.stringify({ type: 'init', sessionId }));
        setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
        resolve(ws);
      });
  

    // Handle WebSocket errors
    ws.addEventListener('error', (error) => {
      console.error(`WebSocket error: ${error.message}`);
      clearTimeout(heartbeatTimeout);
      reject(error);
    });

    // Clear heartbeat on close
    ws.addEventListener('close', () => {
      clearTimeout(heartbeatTimeout);
    });
  });
}

 
  /**
   * Send a POST request and return a JSON response.
   * @param {string} url - The URL to send the request to.
   * @param {object} data - The data to send in the request body.
   * @returns {Promise<object>} - A promise that resolves to the response data.
   */
  async function postData(url, data) {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  
    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Server responded with ${response.status}: ${text}`);
    }
  
    return await response.json();
  }
  
  export async function queryUniversal(data, modelUrl, type = 'hf', model_type = null, element_id = null) {

    const ecid = document.getElementById('ecid_session').value;
 console.log(element_id);
    console.log('start generate');
    if (type === 'hf') { console.log('hf'); 
       toggleLoadingState(true,element_id);
        // Hugging Face API logic
        try { 
            const response = await fetch(modelUrl, {
                headers: { "Accept": "image/png",Authorization: `Bearer ${HF_ACCESS_TOKEN}`,"Content-Type": "application/json"  },
                method: "POST",
                body: JSON.stringify({ "inputs": data }),
            });

            if (!response.ok) {
                throw new Error(`API call failed with status: ${response.status}`);
            }

            toggleLoadingState(false,element_id);

            if (response.headers.get("content-type")?.includes("image")) {
                const imageBlob = await response.blob();
                return URL.createObjectURL(imageBlob);
            } else {
                return await response.text();
            }
        } catch (error) {alert('error'); 
            console.error("Hugging Face API error:", error);
            throw error;
        }
    } else if (type === 'replicate') {
        // Replicate API logic
        const wsUrl = 'wss://i.expresscreations.co.uk/generate/ws';
        const apiUrl = 'https://i.expresscreations.co.uk/generate/start-prediction';

        let ws;

        try {
            ws = await initWebSocket(wsUrl,ecid);
        } catch (error) {
            console.error(`WebSocket error observed: ${error}`);
            throw error;
        }

        ws.addEventListener('open', () => {
            // WebSocket is open and ready
        });

        ws.addEventListener('error', (error) => {
            console.error("WebSocket error:", error);
            throw error;
        });

        ws.addEventListener('message', (event) => {
            const message = JSON.parse(event.data);
            console.log(message);
            if (message.type === 'progress') {
                updateLoadingProgress(message.data, element_id);
            }

            if (message.type === 'succeeded') {
                updateLoadingProgress(message.data, element_id);
            }
        });

        try {
            const responseJson = await postData(apiUrl, { sessionId: ecid, inputImage: { image: data }, model_type: model_type });
            const adaptedJson = typeof responseJson === 'string' ? { image: responseJson } : responseJson;
            const predictionId = responseJson.predictionId;
            let imageUrl; // Declare imageUrl variable

               // Check if responseJson directly contains an image property
            // Check if responseJson is a string (assuming direct URL)
    if (typeof responseJson === 'string') {
        imageUrl = responseJson;
    }
    // Check if responseJson is an array (assuming the first element is the desired URL)
    else if (Array.isArray(responseJson) && responseJson.length > 0) {
        imageUrl = responseJson[0];
    }
    // Fallback or error handling if no URL is found
    else {
        throw new Error("No image URL found in the response");
    }

    const imageElement = document.querySelector(`image[data-item-id="${element_id}"]`);

    if (imageElement && imageUrl) { // Use imageUrl to set attribute
        imageElement.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', imageUrl);
    } else {
        throw new Error("Either imageElement or json.fileUrl is undefined");
    }

            if (ws.readyState === WebSocket.OPEN) {
                ws.send(JSON.stringify({ predictionId, element_id }));
            } else {
                throw new Error("Can't send data because WebSocket is not open.");
            }
        } catch (error) {
            console.error("Replicate API error:", error);
            throw error;
        }
    } else {
        throw new Error('Invalid type');
    }
}


export async function generateContentUniversal(type = 'background', retryCount = 0, inputData = null, element_id = null) {
    const maxRetries = 0;
    let inputText;

    let sendText, modelUrl, queryType;
    console.log('input');
console.log(inputData);
   switch (type) {
        case 'background':
            sendText = `Given the description: '${inputData}', generate a greeting card background with a ratio of 3:2, family friendly. 4k,high definition, middle clear`;
            modelUrl = "https://gxzzyt5ehp5e6y4e.us-east-1.aws.endpoints.huggingface.cloud";
            break;
        case 'text':
            sendText = `Generate a text based on: '${inputData}'.`;
            modelUrl = "https://api-inference.huggingface.co/models/text-model";
            break;
        case 'photo_manipulation':
            sendText = `Manipulate the photo based on: '${inputData}'.`;
            modelUrl = "https://api-inference.huggingface.co/models/photo-manipulation-model";
            break;
        case 'image_restore':
            sendText = inputData; 
            modelUrl = "https://replicate.com/arielreplicate/deoldify_image/api";
            break;
        default:
            sendText = inputData;
            modelUrl = "https://api-inference.huggingface.co/models/default-model";
    }

    if (element_id) {
        queryType = 'replicate';
    } else {
        queryType = 'hf';
    }
    console.log('start');
    console.log(element_id);
    try {
        console.log(sendText, modelUrl, 'hf',type,element_id);
        const generatedContent = await queryUniversal(sendText, modelUrl, 'replicate',type,element_id); //IMPORTANT hf hardcoded
        displayGeneratedContent(type, generatedContent, element_id);
    } catch (error) {
        if (retryCount < maxRetries) {
            generateContentUniversal(type, retryCount + 1, inputData, element_id);
        } else {
            alert("There was an error processing your request.");
        }
    }
}




function displayGeneratedContent(type, content,element_id) {
    console.log('display');
console.log(element_id);
    switch (type) {
        case 'background':
            const backgroundRect = document.getElementById(element_id);
            if (!backgroundRect) {
                console.error(`Element with ID ${element_id} not found`);
                return;
            }

            const svgRoot = backgroundRect.ownerSVGElement;
            const patternId = `backgroundPattern-${element_id}`;
            
            // Remove any existing pattern with the same ID
            let existingPattern = svgRoot.querySelector(`#${patternId}`);
            if (existingPattern) {
                existingPattern.remove();
            }

            const pattern = document.createElementNS("http://www.w3.org/2000/svg", "pattern");
            pattern.setAttribute("id", patternId);
            pattern.setAttribute("width", "1");
            pattern.setAttribute("height", "1");

            const image = document.createElementNS("http://www.w3.org/2000/svg", "image");
            image.setAttributeNS("http://www.w3.org/1999/xlink", "href", content);

            // Set image dimensions to match the SVG element's dimensions
            let originalWidth = parseFloat(backgroundRect.getAttribute("width"));
            let originalHeight = parseFloat(backgroundRect.getAttribute("height"));
            image.setAttribute("width", originalWidth);
            image.setAttribute("height", originalHeight);
            image.setAttribute("preserveAspectRatio", "xMidYMid slice");

            pattern.appendChild(image);

            let defs = svgRoot.querySelector("defs");
            if (!defs) {
                defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
                svgRoot.appendChild(defs);
            }
            defs.appendChild(pattern);

            // Update the fill of the background rect to use the new pattern
            backgroundRect.setAttribute("fill", `url(#${patternId})`);
            break;

        case 'text':
            const textContainer = document.getElementById('generatedText');
            textContainer.textContent = content;
            break;

        case 'photo_manipulation':
            const photoContainer = document.getElementById('manipulatedPhoto');
            photoContainer.src = content;
            break;


        default:
            console.warn('Unknown content type:', type);
    }
}

function toggleLoadingState(isLoading, targetDivId) {
    const generateButton = document.getElementById('generateButton');
    const targetDiv = targetDivId ? document.getElementById(targetDivId) : null;

    if (isLoading) {
        generateButton.textContent = 'Loading...';
        if (targetDiv) {
            targetDiv.style.animation = "loadingColor 2s infinite";
        }
    } else {
        generateButton.textContent = 'Generate';
        if (targetDiv) {
            targetDiv.style.animation = "none";
        }
    }
}


function toggleLoadingStateOld(isLoading) {
    const generateButton = document.getElementById('generateButton');
    const backgroundRect = document.getElementById('customBackgroundRect');
    
    if (isLoading) {
        generateButton.textContent = 'Loading...';
        
        // Apply the loading animation
        backgroundRect.style.animation = "loadingColor 2s infinite";
    } else {
        generateButton.textContent = 'Generate';
        
        // Reset the SVG background
        backgroundRect.style.animation = "none";
    }
}
